import { createAction } from '@reduxjs/toolkit'
import { ScheduledReport } from './automatedReportingTypes'

export const getScheduledReports = createAction(
  'AutomatedReporting/getScheduledReports'
)

export const getScheduledReportRuns = createAction(
  'AutomatedReporting/getScheduledReportRuns'
)

export const createScheduledReport = createAction<ScheduledReport>(
  'AutomatedReporting/createScheduledReport'
)

export const updateScheduledReport = createAction<ScheduledReport>(
  'AutomatedReporting/updateScheduledReport'
)

export const automatedReportingAsyncActions = {
  getScheduledReports,
  getScheduledReportRuns,
  createScheduledReport,
  updateScheduledReport,
}
